// extracted by mini-css-extract-plugin
module.exports = {"error_container":"fetch_error_error_container__23j-L","cancel_button":"fetch_error_cancel_button__16VE_","cancel_icon":"fetch_error_cancel_icon__1y9yl"};